import React from "react";
import styles from "./Page02.module.scss";
import { useUi } from "@jelly/lesson";

export interface Lesson0704Page02Props {
  leftImageUrl: string;
  layoutHeader?: string;
  upperLayerImageUrl: string;
  highLayerImageUrl: string;
  middleLayerImageUrl: string;
  bottomLayerImageUrl: string;
  upperLayerText: string;
  highLayerText: string;
  middleLayerText: string;
  bottomLayerText: string;
  footerText?: string;
}

export const Lesson0704Page02: React.FC<Lesson0704Page02Props> = (props) => {
  const ui = useUi();
  const [rightImageUrl, setRightImageUrl] = React.useState<string>(props.middleLayerImageUrl);

  const footerEntries = props.footerText ? props.footerText.split(",") : [];
  const footerGroups: string[][] = [];

  for (let i = 0; i < footerEntries.length; i += 4) {
    footerGroups.push(footerEntries.slice(i, i + 4));
  }

  const onSwitchOptionChange = (index: number): void => {
    switch (index) {
      case 0:
        setRightImageUrl(props.upperLayerImageUrl);
        break;
      case 1:
        setRightImageUrl(props.highLayerImageUrl);
        break;
      case 2:
        setRightImageUrl(props.middleLayerImageUrl);
        break;
      case 3:
        setRightImageUrl(props.bottomLayerImageUrl);
        break;
      default:
        setRightImageUrl(props.upperLayerImageUrl);
        break;
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.mainSection}>
        <div className={`${styles.firstCol} ${styles.col}`}>
          <img src={props.leftImageUrl} alt="Laouspeakers layout" className={styles.leftImage} />
        </div>
        <div className={`${styles.firstCol} ${styles.col}`}>
          {props.layoutHeader && <h2>{props.layoutHeader}</h2>}
          <img src={rightImageUrl} alt="Loudspeakers layout" className={styles.leftImage} />
          <ui.SwitchOption
            items={[
              { name: props.upperLayerText },
              { name: props.highLayerText },
              { name: props.middleLayerText },
              { name: props.bottomLayerText },
            ]}
            activeItem={1}
            onClick={(index) => {
              onSwitchOptionChange(index);
            }}
          />
        </div>
      </div>
      {props.footerText && props.footerText.length > 0 && (
        <div className={styles.footerSection}>
          {footerGroups.map((group, index) => (
            <div key={`lesson0601_group_${index}`} className={styles.footerGroup}>
              {group.map((item: string, itemIndex) => (
                <div key={`lesson0601_group_item_${index}_${itemIndex}`} className={styles.footerText}>
                  {item}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
